/* Shared feature switch service */

let features = {};

export default {
  init(map) {
    features = map || {};
  },

  enabled(key) {
    if (key) {
      return features[key] === true;
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./common/features.es6